<template lang="pug">
  transition(name='fade')
    b-card.ls-machines-analytics-panel-machine.card-white.card-no-gutters.shadow(no-body)
      b-card-header.bg-transparent.border-0
        h5.m-0
          i.fa-fw.fal.fa-conveyor-belt-alt
          |  {{ $t('analytic.titles.machine') }}
      b-card-body.d-flex.justify-content-center.align-items-center.pt-0
        .chart-wrapper(:style='`width: ${width}; height: ${height};`')
          client-only
            v-chart.chart(
              ref='chart'
              :option='chart'
              :loading='isLoading'
              :loadingOptions='loadingOptions'
              :group='group'
              autoresize)
</template>

<script>
import { ChartsBar } from '@common/charts/bar'

export default {
  name: 'ls-machines-analytics-panel-machine',
  mixins: [ChartsBar],
  props: {
    namespace: String,
    animation: {
      type: Boolean,
      default: true,
    },
  },
  watch: {
    'panel.data'() {
      this.chart.legend.data = Object.keys(this.panel.data.attributes.chart).map((x) =>
        this.$t(`analytic.charts.machine.legends.${x}`)
      )
      for (const [key, value] of Object.entries(this.panel.data.attributes.chart)) {
        const name = this.$t(`analytic.charts.machine.legends.${key}`)
        const series = this.chart.series.find((x) => x.name === name)
        if (series) {
          series.data = value
        } else {
          this.chart.series.push({
            name: name,
            type: 'bar',
            barCategoryGap: '3%',
            showSymbol: false,
            data: value,
          })
        }
      }
    },
  },
  data() {
    return {
      cacheType: `${this.namespace}/getPanelMachine`,
      cacheOptions: { timeout: this.$wc.conf.cache.charts },
      cachePayload: { machine_id: this.$route.params.machine_id, ...this.data },
      skipNotifications: true,
      chart: {
        animation: this.animation,
        grid: {
          top: 15,
          bottom: '25%',
          left: 40,
          right: 12,
        },
        tooltip: {
          trigger: 'axis',
          valueFormatter: (value) =>
            value
              ? this.$t('analytic.charts.machine.values.power_on')
              : this.$t('analytic.charts.machine.values.power_off'),
        },
        legend: {
          data: [],
          show: false,
        },
        xAxis: {
          type: 'time',
          boundaryGap: false,
          axisLabel: {
            hideOverlap: true,
          },
        },
        yAxis: {
          type: 'value',
          name: this.$t('analytic.charts.machine.axis.power'),
          nameLocation: 'center',
          nameGap: 28,
          splitNumber: 1,
          min: 0,
          max: 1,
        },
        series: [],
      },
    }
  },
}
</script>
